import { render, staticRenderFns } from "./MerchantWiseDispatchedReport.vue?vue&type=template&id=b072e80a&"
import script from "./MerchantWiseDispatchedReport.vue?vue&type=script&lang=js&"
export * from "./MerchantWiseDispatchedReport.vue?vue&type=script&lang=js&"
import style0 from "./MerchantWiseDispatchedReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports